import Button from "components/button/Button";
import Input from "components/formInput/Input";
import SelectComponent from "components/select/Select";
import { apiSendCodeDelete, apiSendPhoneDelete } from "helpers/api/accounts";
import useNotify from "hooks/useNotify";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const status = {
  SEND_PHONE: "SEND_PHONE",
  SENT_OTP: "SENT_OTP",
  DELETE_ACCOUNT_SUCCESS: "DELETE_ACCOUNT_SUCCESS",
};

// Đầu số quốc gia — đồng bộ với enum DialPhoneNumberType ở mobile
const DIAL_OPTIONS = [
  { value: "81", label: "+81 JP" },
  { value: "82", label: "+82 KR" },
  { value: "886", label: "+886 TW" },
  { value: "86", label: "+86 CN" },
  { value: "852", label: "+852 HK" },
  { value: "01", label: "+01 US" },
];

// Ghép đầu số + số nội địa thành số quốc tế đầy đủ (giống mobile:
// bỏ 1 số 0 ở đầu rồi prepend dial). VD: dial "81" + "08046878614" -> "818046878614"
const buildInternationalPhone = (dialCode, rawPhone) => {
  let digits = (rawPhone || "").replace(/\D/g, "");
  if (digits.startsWith("0")) digits = digits.slice(1);
  return dialCode + digits;
};

const DeletePassword = () => {
  const { t } = useTranslation();
  const { showToastError } = useNotify();

  const [passwordStatus, setPasswordStatus] = useState(status.SEND_PHONE);
  const [otp, setOtp] = useState("");
  const [isOtpError, setIsOtpError] = useState(false);
  const [phone, setPhone] = useState("");
  const [dial, setDial] = useState("81");

  const handleGetOtp = () => {
    apiSendPhoneDelete(buildInternationalPhone(dial, phone))
      .then((resp) => {
        if (resp?.data) {
          if (passwordStatus !== status.SENT_OTP) {
            setPasswordStatus(status.SENT_OTP);
          }
        } else {
          showToastError(t("delete_account_page.user_not_exist"));
        }
      })
      .catch((err) => {
        showToastError(t('error_msg.account_not_found'));
      });
  };

  const onResend = () => {
    handleGetOtp();
  };

  const handleSendOtp = () => {
    apiSendCodeDelete({code: otp, phone: buildInternationalPhone(dial, phone)})
      .then((resp) => {
        if (resp?.data) {
          setPasswordStatus(status.DELETE_ACCOUNT_SUCCESS);
          setPhone("");
        } else {
          setIsOtpError(true);
        }
      })
      .catch((err) => {
        showToastError(err.message);
        setIsOtpError(true);
      });
  };

  if (passwordStatus === status.SENT_OTP) {
    return (
      <form className="delete-account-container">
        <div className="header-container">
          <div className="header-container-left">
            <div className="header-item">
              <img src="/icons/logo.png" className="logo-icon" alt="" />
            </div>
            <div className="reset-header-container-item">
              <div className="reset-header-screen-name">
                {t("delete_account_page.title")}
              </div>
            </div>
          </div>
        </div>
        <div className="delete-account-col delete-account-content">
          <div className="delete-account-col">
            <div>
              <Input
                width={400}
                name="opt"
                value={otp}
                placeholder={t("delete_account_page.otp_placeholder")}
                onChange={(e) => setOtp(e.target.value)}
                error={
                  isOtpError ? (
                    <>
                      {t("delete_account_page.error_opt_wrong")}
                      <br />
                      {t("delete_account_page.re_send_opt")}
                    </>
                  ) : (
                    ""
                  )
                }
              />
            </div>
          </div>
          <Button
            key="back"
            text={t("delete_account_page.certificate")}
            type="button"
            background="#0E6FBA"
            width={400}
            disabled={!otp}
            style={{ marginTop: 50 }}
            onClick={handleSendOtp}
          />
          <div className="delete-account-row-link-center">
            <div className="delete-account-link" onClick={onResend}>
              {t("delete_account_page.re_send_otp")}
            </div>
          </div>
        </div>
      </form>
    );
  } else if (passwordStatus === status.DELETE_ACCOUNT_SUCCESS) {
    return (
      <div className="delete-account-container">
        <div className="header-container mb-30">
          <div className="header-container-left">
            <div className="header-item">
              <img src="/icons/logo.png" className="logo-icon" alt="" />
            </div>
            <div className="reset-header-container-item">
              <div className="reset-header-screen-name">
                {t("delete_account_page.title")}
              </div>
            </div>
          </div>
        </div>
        <div className="delete-account-content delete-account-success">
          {t("delete_account_page.delete_success")}
        </div>
      </div>
    );
  }

  return (
    <form className="delete-account-container">
      <div className="header-container">
        <div className="header-container-left">
          <div className="header-item">
            <img src="/icons/logo.png" className="logo-icon" alt="" />
          </div>
          <div className="reset-header-container-item">
            <div className="reset-header-screen-name">
              {t("delete_account_page.title")}
            </div>
          </div>
        </div>
      </div>
      <div className="delete-account-col">
        <div className="delete-account-col delete-account-content">
          <div className="facility-name-label">
            {t("delete_account_page.title_send_phone1")}
            <br />
            {t("delete_account_page.title_send_phone2")}
          </div>
          <div
            className="mt-20 delete-account-phone-row"
            style={{ width: 400, display: "flex", gap: 8 }}
          >
            <SelectComponent
              width={120}
              value={dial}
              options={DIAL_OPTIONS}
              onChange={(val) => setDial(val)}
            />
            <Input
              width={272}
              name="phone"
              placeholder={t("delete_account_page.phone_placeholder")}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <Button
            key="back"
            text={t("delete_account_page.send")}
            type="button"
            background="#0E6FBA"
            width={400}
            disabled={!phone}
            style={{ marginTop: 50 }}
            onClick={handleGetOtp}
          />
        </div>
      </div>
    </form>
  );
};
export default DeletePassword;
